import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import type { QueryKey } from '@tanstack/react-query';

export const GET_DISCOUNT_GROUPS = 'api/posv3/maintenance/discount_group_lists';

export const discountGroupsQueryKey: QueryKey = ['discount-groups'];

export type DiscountGroup = {
  Active: boolean;
  Expired: boolean;
  GroupName: string;
  Id: number;
};

export function useGetDiscountGroupsQuery() {
  return useQuery({
    queryKey: discountGroupsQueryKey,
    queryFn: () => fetchData<DiscountGroup[]>(GET_DISCOUNT_GROUPS),
  });
}
